import React from 'react'

import { ArrowDropDown, ArrowDropUp, ArrowLeft, ArrowRight } from '@mui/icons-material'

import './RankChange.scss'

interface Props {
  rankNow: number
  rankPreviously: number
}

const RankChange: React.FC<Props> = (props: Props) => {
  const maxDisplayedRank = 200
  const rankChange = props.rankPreviously - props.rankNow
  const rankOutsideOfMaxDisplay = props.rankPreviously === 0 && props.rankNow > maxDisplayedRank
  const rankInsideOfMaxDisplay = props.rankPreviously === 0 && props.rankNow < maxDisplayedRank

  const getChangeArrow = () => {
    if (rankChange === 0 || rankOutsideOfMaxDisplay) {
      return (
        <>
          <ArrowLeft />
          <ArrowRight />
        </>
      )
    } else if (rankChange > 0 || rankInsideOfMaxDisplay) {
      return <ArrowDropUp color="success" />
    } else {
      return <ArrowDropDown color="warning" />
    }
  }

  return (
    <div className="RankChange">
      {getChangeArrow()}
      {(rankChange !== 0 && props.rankPreviously !== 0) || rankInsideOfMaxDisplay ? (
        <span className="RankChange__previous">{props.rankPreviously > maxDisplayedRank || rankInsideOfMaxDisplay ? '200+' : props.rankPreviously}</span>
      ) : null}
    </div>
  )
}

export default RankChange
